import amplifyConfig from '../config';
import API_PATH from './endpoints';
import axiosInstance from '../utils/axios';
import type { AxiosResponse } from 'axios';
import type { ResetPasswordParams } from '../types/session';

const sessionAPI = {
  /**
   * パスワードリセット
   * @param ResetUserPasswordParams
   * @return UserType
   */
  resetPassword: async (params: ResetPasswordParams) => {
    return axiosInstance.post<ResetPasswordParams, AxiosResponse<void>>(amplifyConfig.apiGateway.URL + API_PATH.SESSION.RESET_PASSWORD, params);
  },
};

export default sessionAPI;
